const Modules = require("@/model/modules");

const STATE_MAP = Modules.getModuleStateName();

export default function projectRoleFromCreds(value) {
    return STATE_MAP[value] || "inconnu";
}
